import React from 'react'
import { Whisper, Tooltip } from 'rsuite'
import { Cell } from 'rsuite-table'
import './VerifiedCell.scss'

type VerifiedCellProps = {
  rowData?: Record<string, any>
  dataKey: string
  verifiedLabel?: string
  unverifiedLabel?: string
}

const VerifiedCell: React.FC<VerifiedCellProps> = ({
  rowData,
  dataKey,
  verifiedLabel = 'Verified',
  unverifiedLabel = 'Unverified',
  ...props
}) => {
  const isVerified = rowData?.[dataKey] === true
  const tooltipText = isVerified ? verifiedLabel : unverifiedLabel

  return (
    <Whisper
      placement="bottom"
      trigger="hover"
      speaker={<Tooltip>{tooltipText}</Tooltip>}
    >
      <Cell {...props}>
        <span
          className={`verified-cell ${isVerified ? 'verified-cell--verified' : 'verified-cell--unverified'}`}
        >
          <span className="verified-cell__dot" />
          {tooltipText}
        </span>
      </Cell>
    </Whisper>
  )
}

export default VerifiedCell
